import React from 'react'
import tagList from '../dataStruct/tagList.json'
import './../helper/dropdown.css'
import EpflLoader from '../helper/EpflLoader'


//var list = JSON.parse(JSON.stringify(listRef));


// keep only entry which fulfill the boolean condition {l["c2013"] !== "-"}
//list = list.filter((l,i,list) => l["c2013"] !== "-");

const rmKey =  ["c2013", "c2016Density","c20162D",  "c2016AS",  "c2016DH",  "c2016BP","PSF","Runby","FIT"]


var uniqueID = 0;
const getUniqueID = () => {
    uniqueID = uniqueID + 1;
    return uniqueID;
}

class SoftwareList extends React.Component {

    constructor(props){
        super(props);
        this.tagList = tagList;
        this.uniqueID = 0;
        let filterList = JSON.parse(JSON.stringify(tagList));
        // create filterList object which has same struct as tagList
        this.filterList = filterList.map(tag => {
            let key = Object.keys(tag);
            let sublist = tag[key];
            var obj = {};
            sublist.forEach((t) => {return (obj[t]= false)})
            //console.log(obj)
            return obj;
        })
        this.timeout=null;
        //console.log(this.filterList[0]["Fluctuation"])
        this.state = {isChecked: false,
                        isLoading:false,
                        response:0,
                        list:[undefined],
                        filteredList:[undefined],
                        sortAscend:true}

        this.filterTable.bind(this)
        this.getHeader.bind(this);
        this.getRowsData.bind(this);
        this.getKeys.bind(this);
        this.containsObject.bind(this);
        this.doDelayedUpdate.bind(this);
        this.objectWithoutKey.bind(this);
        this.renderRow.bind(this);
        this.sortObjectList.bind(this);
        
        }

        objectWithoutKey = (object, key) => {
            key.forEach( (k) => {delete object[k]})
            return object
          }

        getKeys(){
            return Object.keys(this.state.list[0]);
        }
        
        getHeader(){
            var keys = this.getKeys();
            return keys.map((key, index)=>{
                if (key !== "Open_access")
                    return <th className="hoverRed" data-tablesaw-sortable-col key={getUniqueID()} 
                    onClick={()=> this.sortObjectList(key)}>{key.toUpperCase()}</th>
            })
        }

        getRowsData(){
            var keys = this.getKeys();
            return this.state.filteredList.map((row, index)=>{
            return <tr key={getUniqueID()}>
                        {this.renderRow(index,row,keys)}
                        {/*<RenderRow key={index} data={row} keys={keys} />*/}
                    </tr>
            })
        }

        renderRow(index,row,keys){
            return keys.map( entry => {
                if (entry !== "Open_access")
                    if ((entry === "Accessibility") & (row["Open_access"] !== "-")) // if url is provided, render accessibility as a link
                        return <td key={getUniqueID()}><a href={row["Open_access"]} target="_blank">{row[entry]}</a></td>
                    else
                        return <td key={getUniqueID()}>{row[entry]}</td>
            })
           }

        containsObject(obj, list) {
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i] === obj) {
                    return true;
                }
            }
            return false;
        }

        sortObjectList(key){
            
            // sort software object list based on input key and update filteredList
            let sortedList = this.state.filteredList;

            sortedList = sortedList.sort((a,b) => {

                let cp = a[key][0].toUpperCase()>b[key][0].toUpperCase()
                if (this.state.sortAscend === true)
                    return cp
                else
                    return !cp
            })

            this.setState({filteredList:sortedList,sortAscend:!this.state.sortAscend})
            
        }

        fetchSoftwareList(){
            const fetchPath = "/api/getSoftwareList"
            this.setState({isLoading:true,response:0})
            fetch(fetchPath,
            {
                method: 'get',
                headers: {
                    "Accept": "application/text"
                },
                mode: 'same-origin'
            }).then (response => {
                if (response.ok) {
                    response.json().then(r => {
                        // response contains two lists: headers and data
                        
                        var filteredList = r["list"];
                        // single line code to filter keys from the list of object
                        filteredList.forEach((l,i,filteredList) => {filteredList[i] = this.objectWithoutKey(l,rmKey)});
                        
                        this.setState({list:r["list"],
                                        filteredList:filteredList,
                                        response:1,
                                        isLoading:false})
                        window.Tablesaw.init()
                    })
                } else {
                    this.setState({response:-1,isLoading:false})
                }
            })
        }

        componentDidMount() {
            // init the table once dom is mounted
            this.fetchSoftwareList();
        }

        doDelayedUpdate(i,t,str) {
            if( this.timeout) {
                clearTimeout(this.timeout);
            }
            
            this.timeout = setTimeout(() => this.filterTable(i,t,str)
                , 500);
        }

        filterTable(i,t,str){
            
            var tmp = JSON.parse(JSON.stringify(this.state.list));
            tmp.forEach((l,i,tmp) => {tmp[i] = this.objectWithoutKey(l,rmKey)});
            
            //tmp = tmp.filter((l,i,tmp) => l["c2013"] !== "-");
            if (i >= 0) {
                // update filterList object
                this.filterList[i][t] = !this.filterList[i][t];

                //if (this.filterList[i][t]  === true) {
                //    tmp = tmp.filter((l) => (l["Platform"].includes(t)));
                //}
            }
            let flist = this.filterList[5] //5 is for Language Tag
            let keys = Object.keys(flist)
            if (keys.some(k => flist[k] === true)) {
                    tmp = tmp.filter(l => {
                    return keys.some((f,i) => {return (l["Platform"].includes(f) && flist[f] === true)})
                });
            }
            if (str !== "") { // is not an empty string
                // loop through all entries
                str = str.toUpperCase()
                tmp = tmp.filter( l => {
                    let keys = Object.keys(l);
                    // returns true if at least one fields matches the string
                    return keys.some(k => l[k].toUpperCase().includes(str))
                });
            }
            
            this.setState({filteredList:tmp});
            window.Tablesaw.init()
        }

    render() {
            return (
            <div style={{margin: '25px 50px 75px 50px', display: "block"}} >
                <div className="controlHead">
                    <span>
                        <button className="btn btn-primary" style={{margin: "5px"}}
                            onClick={ () => {
                                const element = document.createElement("a");
                                const file = new Blob([JSON.stringify(this.list,null,2)],    
                                            {type: 'text/plain;charset=utf-8'});
                                element.href = URL.createObjectURL(file);
                                element.download = "softwareList.json";
                                document.body.appendChild(element);
                                element.click();
                            }
                            }>
                            Download current list{' '}
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#icon-upload"></use>
                            </svg>
                        </button>
                    </span> 
                    {
                        /*
                    <span className="dropdown">
                        <button className="btn btn-primary" style={{margin: "5px"}}> Show filters</button>
                        <span className="dropdown-content"> 
                            <div className="grid-container">
                                {this.tagList.map((subList,i) => {
                                const tags = subList[Object.keys(subList)];
                                let tagName = Object.keys(subList)
                                
                                const out = tags.map((t) => {
                                    return (
                                        <span className="custom-control custom-checkbox" key={t}>
                                            <input type="checkbox" className="custom-control-input" id={tagName[0]+"_"+t} name={t}
                                            onChange={() => this.filterTable(i,t,"")}/> 
                                            <label className="custom-control-label" htmlFor={tagName[0]+"_"+t}> {t}</label>
                                        </span>
                                    )
                                    });
                                    return (
                                        <div className="grid-item" key={tagName}>
                                            <h5>{tagName}</h5>
                                            {out}
                                        </div>
                                        )
                                    })
                                }
                            </div>
                        </span>
                    </span>
                    */}
                    {//<button className="btn btn-primary" style={{margin: "5px"}}
                     //   onClick={() => this.props.history.push("/SoftwareList/SubmitSoftware")}> Propose new software entry</button>
                    }
                    {// <button className="btn btn-primary" style={{margin: "5px"}}> Localization softwares</button>
                    }
                
                    <div style={{marginLeft:"auto",margin: "5px"}}>
                        <input type="text" placeholder="Search..." id="searchText"
                        onChange={() => this.doDelayedUpdate(-1,-1,document.getElementById("searchText").value)}/>
                    </div>
                </div>
                <br></br>
                {this.state.response === 0 && this.state.isLoading === true &&
                <div style={{margin:"10px"}}>
                    <EpflLoader/>
                </div>}
                <div className="tablesaw-bar tablesaw-mode-stack" style={{margin: "5px"}}/>
                { this.state.response === 1 &&
                (this.state.list[0]!== undefined ?
               // <table id="tablesaw1" className="table table-sortable tablesaw-stack tablesaw-sortable" data-tablesaw-sortable="true">
                <table id="tablesaw1" className="table table-sortable tablesaw-stack tablesaw-sortable">    
                    <thead>
                        <tr>{this.getHeader()}</tr>
                    </thead>
                    <tbody>
                        {this.getRowsData()}
                    </tbody>
                </table>
                :
                <h5>No entry found. Try removing some filters or use another search word</h5>
                )}
            </div>
            );
    }
    
}

export default SoftwareList;


